export const NAME = "public/emailVerified";
